const changeFile = ({ content, options, octokit, type }) => {
  const o = { ...options, path: options.path + '.' + type };

  return octokit.repos
    .getContents(o)
    .then(file => {
      console.log('update');
      return octokit.repos.createOrUpdateFile({
        ...o,
        message: 'update from like Water',
        content: window.btoa(content),
        sha: file.data.sha
      });
    })
    .catch(() => {
      console.log('create');
      return octokit.repos.createOrUpdateFile({
        ...o,
        message: 'update from like Water',
        content: window.btoa(content)
      });
    });
};

export default changeFile;
